import axiosInstance from 'api/axiosInstance';
import dayjs from 'dayjs';
import { stringify } from 'query-string';
import type { Supplier, SupplierAsOption } from 'types/expenses.types';
import type { CategoryAPI } from 'types/expensesCategory.types';
import type { Period } from 'types/global.types';
import type { UserCountry, UserLanguage } from 'types/users.types';

const expensesService = '/v1/expenses';
const calcService = '/v1/calculations/expenses';

export const getCurrentYearDeductibleAmount = (): Promise<{
  amount: number;
}> => {
  const query = {
    year: dayjs().year(),
    endDate: dayjs().format('YYYY-MM-DD'),
  };
  return axiosInstance.get(`${calcService}/deductible?${stringify(query)}`);
};

export const getCurrentPeriodDeductibleAmount = (
  params: Period & { endDate: string },
): Promise<{
  amount: number;
}> => {
  return axiosInstance.get(`${calcService}/deductible?${stringify(params)}`);
};

export const getSuppliers = (name: string): Promise<Supplier[]> => {
  return axiosInstance.get(
    `${expensesService}/guessMerchantData?name=${encodeURIComponent(name)}`,
  );
};

export const getSuppliersOptions = (
  name: string,
): Promise<SupplierAsOption[]> => {
  return getSuppliers(name).then((suppliers) =>
    suppliers.map((supplier) => ({
      label: supplier.name,
      value: supplier.name,
      supplier,
    })),
  );
};

export const getCategories = (
  country: UserCountry,
  lang: UserLanguage,
  params?: Record<string, any>,
): Promise<CategoryAPI[]> => {
  return axiosInstance.get(
    `${expensesService}/categories/${country}?${stringify({
      lang,
    })}`,
    params,
  );
};
